<template lang='pug'>
    div
        ElectricalPDSensorSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")

            section.title-container
                h1.product-title HFCT-90
                h2.product-subtitle Clamp-on HFCT for PD Measurement in IEC60270 Range and Above

            section.margin-bottom
                .column-container
                    .column.center-content
                        img( src='@/assets/photos/HFCT-90.png', width="80%", alt='PD Sensor HFCT-90', title='PD Sensor HFCT-90')
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Contactless PD measurement
                                li Up to 90 mm cables
                                li Up to 400 A 50 Hz current allowed
                                li High common mode rejection
                                li Easy to install
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet HFCT-90.pdf")
                            Maillink(to='support@bss-hs.de', sub='HFCT-90', text='Contact Us', size=30, strokeWidth=2)
                            Sitelink(to="/en/products/PDM-600", text='Partial Discharge Monitoring System PDM-600')
                            Sitelink(to="/en/products/pdm-80", text='Partial Discharge Monitoring System PDM-80')
                            Sitelink(to="/en/products/PDM-600-Mobile", text='PDM-600-Mobile')
                        
            div.margin-bottom
                p The current clamp is used to transfer electrical PD impulses contactless from a test object to a PD measuring system. Due to its large inner diameter, the current clamp can be mounted on conductors with a high cross section. PD can be measured even when high AC currents up to 300 A are superimposed. Unwanted 50 Hz components are not transmitted by the current clamp. With the current clamp, both a PD measurement in the standardized frequency range according to IEC 60270 as well as at higher frequencies up to 10 MHz can be performed.


        div.fullwidth(v-if="$route.params.lang == 'de'")

            section.title-container
                h1.product-title HFCT-90
                h2.product-subtitle Klappwandler für die TE-Messung im IEC60270 Frequenzbereich und höher

            section.margin-bottom
                .column-container
                    .column.center-content
                        img( src='@/assets/photos/HFCT-90.png', width="80%", alt='TE-Sensor HFCT-90', title='TE-Sensor HFCT-90')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Kontaktlose TE-Messung
                                li Bis zu 90 mm Kabeldurchmesser
                                li Bis zu 400 A Betriebsstrom zulässig
                                li Hohe Gleichtaktunterdrückung
                                li Einfache Installation
                        .bluebox
                            Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet HFCT-90.pdf")
                            Maillink(to='support@bss-hs.de', sub='HFCT-90', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/PDM-600", text='Partial Discharge Monitoring System PDM-600')
                            Sitelink(to="/de/products/pdm-80", text='Partial Discharge Monitoring System PDM-80')
                            Sitelink(to="/de/products/PDM-600-Mobile", text='PDM-600-Mobile')
                        
            section.margin-bottom
                p Die Stromzange wird verwendet, um elektrische TE-Impulse kontaktlos von einem Prüfling an ein TE-Messsystem zu übertragen. Die Stromzange kann aufgrund ihrem großen Innendurchmesser an Leitern mit hohem Querschnitt montiert werden und TE selbst bei Überlagerung von hohen AC Strömen bis zu 300 A messen. Unerwünschte 50 Hz Komponenten werden durch die Stromzange nicht übertragen. Mit der Stromzange kann sowohl eine TE-Messung im genormten Frequenzbereich nach IEC 60270 als auch bei höheren Frequenzen bis 10 MHz erfolgen.
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS - TE-Sensor - HFCT-90",
            description:
                "Klappwandler für die Teilentladungs(TE)-Messung im IEC 60270 Frequenzbereich und höher",
        },
        en: {
            title: "BSS - PD Sensor - HFCT-90",
            description:
                "Clamp-on HFCT for Partial Discharge (PD) Measurement in IEC60270 Range and Above",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>